// import Cookies from "js-cookie";
// import { useLogoutMutation } from "../redux/services/authApi";
// import { toast } from "sonner";
// import { useNavigate } from "react-router";
// import { FLEETRIFYROUTEPATH } from "../routes/routesPath";
// import { useAppDispatch } from "../redux/services/store";
// import { clearAuthUser } from "../redux/slices/authSlice";

// export const useLogoutControllers = ({ onClose }: { onClose: () => void }) => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const [logout, { isLoading }] = useLogoutMutation();

//   const clearClient = () => {
//     console.log("[Logout] Clearing client state...");

//     dispatch(clearAuthUser());
//     Cookies.remove("token");
//     localStorage.clear();
//     sessionStorage.clear();

//     console.log("[Logout] Client state cleared");
//   };

//   const handleLogout = async () => {
//     console.log("[Logout] handleLogout triggered");

//     try {
//       console.log("[Logout] Calling logout mutation...");
//       const res = await logout().unwrap();
//       console.log("[Logout] Server logout success:", res);

//       toast.dismiss();
//       toast.success?.("Logged out");
//     } catch (error) {
//       console.error("[Logout] Server logout failed:", error);
//       toast.dismiss();
//       toast("Logged out (client only)");
//     } finally {
//       clearClient();
//       onClose?.();
//       navigate(FLEETRIFYROUTEPATH.LOGIN);
//     }
//   };

//   return {
//     isLoading,
//     handleLogout,
//   };
// };




import Cookies from "js-cookie";
import { useLogoutMutation } from "../redux/services/authApi";
import { toast } from "sonner";
import { useNavigate } from "react-router";
import { FLEETRIFYROUTEPATH } from "../routes/routesPath";
import { useAppDispatch } from "../redux/services/store";
import { clearAuthUser } from "../redux/slices/authSlice";

export const useLogoutControllers = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [logout, { isLoading }] = useLogoutMutation();

  const clearClient = () => {
    console.log("[Logout] Clearing client state...");

    // clear auth slice and storage
    dispatch(clearAuthUser());
    Cookies.remove("token");
    localStorage.clear();
    sessionStorage.clear();

    // full app refresh to clear all caches
    window.location.href = FLEETRIFYROUTEPATH.LOGIN;

    console.log("[Logout] Client state cleared");
  };

  const handleLogout = async () => {
    console.log("[Logout] handleLogout triggered");

    try {
      console.log("[Logout] Calling logout mutation...");
      const res = await logout().unwrap();
      console.log("[Logout] Server logout success:", res);

      toast.dismiss();
      toast.success?.("Logged out");
    } catch (error) {
      console.error("[Logout] Server logout failed:", error);
      toast.dismiss();
      toast("Logged out (client only)");
    } finally {
      clearClient();
      onClose?.();

    }
  };

  return {
    isLoading,
    handleLogout,
  };
};
